var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-circle-fill",
    clipPath: "url(#clip0_705_803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M150 75C150 94.8912 142.098 113.968 128.033 128.033C113.968 142.098 94.8912 150 75 150C55.1088 150 36.0322 142.098 21.967 128.033C7.90176 113.968 0 94.8912 0 75C0 55.1088 7.90176 36.0322 21.967 21.967C36.0322 7.90176 55.1088 0 75 0C94.8912 0 113.968 7.90176 128.033 21.967C142.098 36.0322 150 55.1088 150 75ZM63.6562 47.7469C62.9553 47.2478 62.1306 46.9513 61.2724 46.8899C60.4142 46.8284 59.5556 47.0043 58.7907 47.3984C58.0258 47.7924 57.3842 48.3894 56.936 49.1239C56.4879 49.8584 56.2505 50.7021 56.25 51.5625V98.4375C56.2505 99.2979 56.4879 100.142 56.936 100.876C57.3842 101.611 58.0258 102.208 58.7907 102.602C59.5556 102.996 60.4142 103.172 61.2724 103.11C62.1306 103.049 62.9553 102.752 63.6562 102.253L96.4688 78.8156C97.0764 78.382 97.5717 77.8095 97.9134 77.1459C98.2552 76.4822 98.4334 75.7465 98.4334 75C98.4334 74.2535 98.2552 73.5178 97.9134 72.8541C97.5717 72.1905 97.0764 71.618 96.4688 71.1844L63.6562 47.7469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_705_803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircleFill);
export default __webpack_public_path__ + "static/media/play-circle-fill.933d5778ac0267393be63740fbbee815.svg";
export { ForwardRef as ReactComponent };